import { Controller } from "@hotwired/stimulus"

const DEFAULT_CONFIG = {
  minLength: 8,
  labels: {
    minLength: "Al menos 8 caracteres",
    digit: "Al menos un dígito",
    lower: "Al menos una minúscula",
    upper: "Al menos una mayúscula",
    symbol: "Al menos un símbolo"
  },
  strengthLabels: {
    weak: "Débil",
    fair: "Regular",
    good: "Buena",
    strong: "Fuerte"
  }
}


// Connects to data-controller="password-complexity"
export default class extends Controller {
  static targets = ["password", "feedback", "strength"]

  connect() {
    this.config = DEFAULT_CONFIG
    this.check()
  }

  check() {
    const value = this.passwordTarget?.value ?? ""
    const { minLength, labels } = this.config
    const rules = [
      { key: "length", met: value.length >= minLength, label: labels.minLength },
      { key: "digit", met: /\d/.test(value), label: labels.digit },
      { key: "lower", met: /[a-z]/.test(value), label: labels.lower },
      { key: "upper", met: /[A-Z]/.test(value), label: labels.upper },
      { key: "symbol", met: /[^A-Za-z0-9]/.test(value), label: labels.symbol }
    ]
    this.renderFeedback(rules)
    this.renderStrength(this.getStrengthScore(value))
  }

  renderFeedback(rules) {
    if (!this.hasFeedbackTarget) return
    const checkIcon = "<i class=\"fas fa-check\"></i>"
    const crossIcon = "<i class=\"fas fa-times\"></i>"
    this.feedbackTarget.innerHTML = rules
      .map(
        (r) => `
        <li class="password-requirement ${r.met ? "text-success" : "text-muted"}">
          <span aria-hidden="true">${r.met ? checkIcon : crossIcon}</span> ${r.label}
        </li>
      `
      )
      .join("")
  }

  getStrengthScore(password) {
    if (!password.length) return 0
    let score = 0
    const lengthScore = Math.min(password.length * 5, 40)
    score += lengthScore
    if (/[a-z]/.test(password)) score += 15
    if (/[A-Z]/.test(password)) score += 15
    if (/\d/.test(password)) score += 15
    if (/[^A-Za-z0-9]/.test(password)) score += 15
    return Math.min(score, 100)
  }

  getStrengthLevel(score) {
    if (score <= 25) return { label: this.config.strengthLabels.weak, className: "bg-danger" }
    if (score <= 50) return { label: this.config.strengthLabels.fair, className: "bg-warning" }
    if (score <= 75) return { label: this.config.strengthLabels.good, className: "bg-primary" }
    return { label: this.config.strengthLabels.strong, className: "bg-success" }
  }

  renderStrength(score) {
    if (!this.hasStrengthTarget) return
    const bar = this.strengthTarget.querySelector(".progress-bar")
    if (!bar) return
    const { label, className } = this.getStrengthLevel(score)
    bar.style.width = `${score}%`
    bar.setAttribute("aria-valuenow", score)
    bar.className = `progress-bar ${className}`
    bar.textContent = score > 0 ? label : ""
  }
}
